import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import Footer from "../../../../core/common/Footer";
import AddSingleProgram from "./AddSingleProgram";
import AddBulkProgram from "./AddBulkProgram";

const tabs = [
  {
    id: "addSingle",
    label: "Add Single Program",
  },
  {
    id: "addBulk",
    label: "Bulk Add",
  },
];

const AddProgram = () => {
  const [activeTab, setActiveTab] = useState("addSingle");

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Add Program</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.superAdminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Account Activation</li>
                <li className="breadcrumb-item">Account Configuration</li>
                <li className="breadcrumb-item active">Add Program</li>
              </ol>
            </nav>
          </div>
          <div className="head-icons ms-2">
            <CollapseHeader />
          </div>
        </div>

        <ul className="nav nav-tabs p-2">
          {tabs.map((tab) => (
            <li className="nav-item mx-0" key={tab.id}>
              <button
                className={`nav-link rounded-0 ${activeTab === tab.id ? "active text-light bg-dark" : "border border-dark"}`}
                onClick={() => {
                  setActiveTab(tab.id);
                }}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>

        {/* Tab Content */}
        <div className="my-5">
          {activeTab == "addSingle" && <AddSingleProgram />}
          {activeTab == "addBulk" && <AddBulkProgram />}
        </div>
        {/* /tabs data */}
      </div>
      <Footer />
    </div>
  );
};

export default AddProgram;
